/**
 * 现金红包服务
 * @returns
 */
import BaseServer from '@/domain/common/base.server.js';
import useMsgServer from '@/domain/common/msg.server.js';
import { cashRedpacketApi } from '@/request/index.js';

class CashRedpacketServer extends BaseServer {
  constructor() {
    if (typeof CashRedpacketServer.instance === 'object') {
      return CashRedpacketServer.instance;
    }
    super();

    this.state = {};

    CashRedpacketServer.instance = this;

    this.listenMsg()
    return this;
  }

  setState(key, value) {
    this.state[key] = value;
  }

  listenMsg() {
    // // 房间消息
    useMsgServer().$onMsg('ROOM_MSG', rawMsg => {
      let temp = Object.assign({}, rawMsg);

      if (typeof temp.data !== 'object') {
        temp.data = JSON.parse(temp.data);
        temp.context = JSON.parse(temp.context);
      }
      // console.log(temp, '原始消息');
      const { type = '' } = temp.data || {};
      switch (type) {
        // 现金红包开始消息
        case 'red_packet_open':
        // 现金红包结束消息
        case 'red_packet_end':
        // 直播结束
        case 'live_over':
        // 红包提现状态变更消息
        case 'red_packet_received':
          this.$emit(type, temp);
          break;
        default:
          break;
      }
    });
    // 自定义消息
    // useMsgServer().$onMsg('CUSTOM_MSG', rawMsg => {
    //   let temp = Object.assign({}, rawMsg);

    //   if (typeof temp.data !== 'object') {
    //     temp.data = JSON.parse(temp.data);
    //     temp.context = JSON.parse(temp.context);
    //   }
    //   console.log(temp, '原始消息');
    //   const { type = '' } = temp.data || {};
    //   switch (type) {
    //     // 计时器暂停
    //     case 'timer_pause':
    //       this.$emit('timer_pause', temp);
    //       break;
    //     default:
    //       break;
    //   }
    // });
  }

  getLastInfo(params) {
    return cashRedpacketApi.getLastInfo(params);
  }
  unwrap(params) {
    return cashRedpacketApi.unwrap(params);
  }
  receive(params) {
    return cashRedpacketApi.receive(params);
  }
  getCashRedpacketRank(params) {
    return cashRedpacketApi.getCashRedpacketRank(params);
  }
  getLastInfo(params) {
    return cashRedpacketApi.getLastInfo(params);
  }
  setRedPacketSwitch(params) {
    return cashRedpacketApi.setRedPacketSwitch(params);
  }
  getRedPacketSwitch(params) {
    return cashRedpacketApi.getRedPacketSwitch(params);
  }
  getWithdrawList(params) {
    return cashRedpacketApi.getWithdrawList(params);
  }
}

export default function useCashRedpacketServer() {
  return new CashRedpacketServer();
}
